<template>
  <v-app light>
    <main>
      <v-navigation-drawer
      clipped
      absolute
      permanent
      overflow
      app
      >
        <v-toolbar flat class="transparent" height="90px">
          <v-spacer></v-spacer>
          <img src="~assets/images/logo_althash_health_top.png" alt="Althash Health Logo" class="cursor" @click="changeView('home')">
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat class="transparent" v-if="this.network=='testnet'">
          <v-spacer></v-spacer>
          <b>TESTNET</b>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat class="transparent" v-if="this.localUserValid">
          <v-list class="pa-0">
            <v-divider></v-divider>
            <v-list-tile avatar @click="changeView('user_details')">             
              <v-list-tile-avatar>
                <!--
                <img src="https://randomuser.me/api/portraits/men/85.jpg">
                -->
                <v-icon large v-if="this.localUserName!=''">
                  account_circle
                </v-icon>
                <v-icon large color="error" v-else>
                  error
                </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-if="this.localUserName!=''">
                  {{ this.showName }}
                </v-list-tile-title>
                <v-list-tile-title v-else>
                  Please fill info.
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  icon
                  @click.stop="logout_dialog = true"
                >
                  <v-icon>power_settings_new</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>
        <v-list class="pt-0" dense v-if="this.localUserValid">
          <v-list-tile @click="changeView('view')">
            <v-list-tile-action>
              <v-icon>local_gas_station</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <span>{{ this.wallet.info['balance'] }}</span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-list>
          <v-list-tile
            v-for="item in items"
            v-show="show[item.name]"
            :key="item.title"
            @click="changeView(item.name)"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="this.localUserValid"></v-divider>
          <v-list-group
            v-for = "menu_item in menu"
            :prepend-icon="menu_item.icon"
            :key="menu_item.title"
            :value = "menu_item.active"
            v-show="show[menu_item.name]"
            no-action
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ menu_item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              v-for="(sub_item, i) in menu_item.sub_items"
              :key="i"
              v-show="show[sub_item.name]"
              @click="changeView(sub_item.goto)"
            >
              <v-list-tile-content>
                <v-list-tile-title v-text="sub_item.title"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon v-text="sub_item.icon"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
          <v-divider></v-divider>
          <v-list-tile @click="changeView('settings')">
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <span>Settings</span>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="changeView('help')">
            <v-list-tile-action>
              <v-icon>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <span>Help</span>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon small>email</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <span class="grey--text caption">health@althash.org</span>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

      </v-navigation-drawer>
      <v-content>
        <v-container fluid fill-height justify-center>
          <v-layout row wrap>
            <v-flex xs10 offset-xs1>
              <home v-show="isCurrent['home']" @changeView="changeView"></home>
              <create-wallet :view="isCurrent['create']" @created="setWallet" v-show="isCurrent['create']"></create-wallet>
              <restore-key-file @restored="setWallet" v-show="isCurrent['restore_from_key_file']"></restore-key-file>
              <view-wallet :view="isCurrent['view']" v-if="isCurrent['view']" @openPage="changeView"></view-wallet>
              <view-tx :view="isCurrent['transactions']" v-if="isCurrent['transactions']"></view-tx>
              <send @send="setWallet" v-if="isCurrent['send']"></send>
              <dump-key-file v-if="isCurrent['dump_as_key_file']"></dump-key-file>
              <certstandard-create v-if="isCurrent['certstandard_create']"></certstandard-create>
              <certstandard-read v-if="isCurrent['certstandard_read']"></certstandard-read>
              <certstandard-invalidate v-if="isCurrent['certstandard_invalidate']"></certstandard-invalidate>
              <certdrivers-create v-if="isCurrent['certdrivers_create']"></certdrivers-create>
              <certdrivers-read v-if="isCurrent['certdrivers_read']"></certdrivers-read>
              <user-activate v-if="isCurrent['user_activate']"></user-activate>
              <user-details v-if="isCurrent['user_details']"></user-details>
              <user-read v-if="isCurrent['user_read']" :localUserAccessLevel="localUserAccessLevel"></user-read>
              <user-invalidate v-if="isCurrent['user_invalidate']"></user-invalidate>
              <user-facilities v-if="isCurrent['user_facilities']" :localUserAccessLevel="localUserAccessLevel" :walletAddress="walletAddress" :localUserType="localUserType"></user-facilities>
              <patient-create v-if="isCurrent['patient_create']"></patient-create>
              <patient-read v-if="isCurrent['patient_read']"></patient-read>
              <patient-invalidate v-if="isCurrent['patient_invalidate']"></patient-invalidate>
              <config v-if="isCurrent['settings']"></config>
              <help v-if="isCurrent['help']" @openPage="changeView" :localUserAccessLevel="localUserAccessLevel" :localUserType="localUserType" :localUserValid="localUserValid"></help>
              <help-signup v-if="isCurrent['help-signup']" @openPage="changeView"></help-signup>
              <help-signin v-if="isCurrent['help-signin']" @openPage="changeView"></help-signin>
              <help-userread v-if="isCurrent['help-userread']" @openPage="changeView"></help-userread>
              <help-useractivate v-if="isCurrent['help-useractivate']" @openPage="changeView"></help-useractivate>
              <help-userinvalidate v-if="isCurrent['help-userinvalidate']" @openPage="changeView"></help-userinvalidate>
              <help-userfacilitiesadmin v-if="isCurrent['help-userfacilitiesadmin']" @openPage="changeView"></help-userfacilitiesadmin>
              <help-userfacilities v-if="isCurrent['help-userfacilities']" @openPage="changeView"></help-userfacilities>
              <help-patientcreate v-if="isCurrent['help-patientcreate']" @openPage="changeView"></help-patientcreate>
              <help-patientread v-if="isCurrent['help-patientread']" @openPage="changeView"></help-patientread>
              <help-patientinvalidate v-if="isCurrent['help-patientinvalidate']" @openPage="changeView"></help-patientinvalidate>
              <help-certstandardcreate v-if="isCurrent['help-certstandardcreate']" @openPage="changeView"></help-certstandardcreate>
              <help-certstandardread v-if="isCurrent['help-certstandardread']" @openPage="changeView"></help-certstandardread>
              <help-certstandardinvalidate v-if="isCurrent['help-certstandardinvalidate']" @openPage="changeView"></help-certstandardinvalidate>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </main>
    <v-dialog
      v-model="logout_dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Log out?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            flat="flat"
            @click="logout_dialog = false"
          >
            Stay
          </v-btn>

          <v-btn
            color="error"
            @click="logout"
          >
            Log out
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notify></notify>
    <warning></warning>
  </v-app>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
import Vue from 'vue'
import createLog from 'localstorage-logger'
//Components
import Notify from 'components/Notify'
import Warning from 'components/Warning'
import Home from 'controllers/Home'
import CreateWallet from 'controllers/Create'
import RestoreKeyFile from 'controllers/RestoreKeyFile'
import ViewWallet from 'controllers/View'
import ViewTx from 'controllers/ViewTx'
import Send from 'controllers/Send'
import DumpKeyFile from 'controllers/DumpKeyFile'
import CertstandardCreate from 'controllers/Certstandard-Create'
import CertstandardRead from 'controllers/Certstandard-Read'
import CertstandardInvalidate from 'controllers/Certstandard-Invalidate'
import CertdriversCreate from 'controllers/Certdrivers-Create'
import CertdriversRead from 'controllers/Certdrivers-Read'
import UserActivate from 'controllers/User-Activate'
import UserDetails from 'controllers/User-Details'
import UserRead from 'controllers/User-Read'
import UserInvalidate from 'controllers/User-Invalidate'
import UserFacilities from 'controllers/User-Facilities'
import PatientCreate from 'controllers/Patient-Create'
import PatientRead from 'controllers/Patient-Read'
import PatientInvalidate from 'controllers/Patient-Invalidate'
import Help from 'controllers/Help'
import HelpSignup from 'controllers/Help-Signup'
import HelpSignin from 'controllers/Help-Signin'
import HelpUserread from 'controllers/Help-Userread'
import HelpUseractivate from 'controllers/Help-Useractivate'
import HelpUserinvalidate from 'controllers/Help-Userinvalidate'
import HelpUserfacilitiesadmin from 'controllers/Help-Userfacilitiesadmin'
import HelpUserfacilities from 'controllers/Help-Userfacilities'
import HelpPatientcreate from 'controllers/Help-Patientcreate'
import HelpPatientread from 'controllers/Help-Patientread'
import HelpPatientinvalidate from 'controllers/Help-Patientinvalidate'
import HelpCertstandardcreate from 'controllers/Help-Certstandardcreate'
import HelpCertstandardread from 'controllers/Help-Certstandardread'
import HelpCertstandardinvalidate from 'controllers/Help-Certstandardinvalidate'
import Config from 'controllers/Config'
import config from 'libs/config'
import webWallet from 'libs/web-wallet'
import i18n from 'libs/i18n'
import abi from 'ethjs-abi'
import base58 from 'bs58'

const log = createLog({
  maxLogSizeInBytes: 500 * 1024 // 500KB
})

const contractAddress = config.getNetwork() == "mainnet" ? "1184387fabba8058e3094dbb489be214dba4b770" : "0";

const abiJson = JSON.parse(
  '[{"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_facilityType", "type": "uint8"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserFacilityDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_newLimit", "type": "uint8"} ], "name": "setFacilitiesLimit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilitiesTotal", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "invalidateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkPhysician", "outputs": [{"name": "isPhysician", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "getFacilitiesLimit", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "addPhysicianToFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "removePhysicianfromFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "isUserValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "", "type": "address"} ], "name": "usersAccessLevels", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkFacility", "outputs": [{"name": "isFacility", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserFacilityType", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "activateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilities", "outputs": [{"name": "facility1", "type": "address"}, {"name": "facility1Name", "type": "string"}, {"name": "facility2", "type": "address"}, {"name": "facility2Name", "type": "string"}, {"name": "facility3", "type": "address"}, {"name": "facility3Name", "type": "string"}, {"name": "facility4", "type": "address"}, {"name": "facility4Name", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_PRC", "type": "uint256"}, {"name": "_PRCExpDate", "type": "uint256"}, {"name": "_PTR", "type": "uint256"}, {"name": "_PTRExpDate", "type": "uint256"}, {"name": "_S2", "type": "uint256"}, {"name": "_S2ExpDate", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserPhysicianDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserPhysicianDetails", "outputs": [{"name": "PRC", "type": "uint256"}, {"name": "PRCExpDate", "type": "uint256"}, {"name": "PTR", "type": "uint256"}, {"name": "PTRExpDate", "type": "uint256"}, {"name": "S2", "type": "uint256"}, {"name": "S2ExpDate", "type": "uint256"}, {"name": "updatedBy", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserDetails", "outputs": [{"name": "userType", "type": "uint8"}, {"name": "userFullName", "type": "string"}, {"name": "userEmail", "type": "string"}, {"name": "userPhysicalAddress", "type": "string"}, {"name": "userPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "totalDataInput", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "totalAdmins", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserAccessLevel", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_accessLevel", "type": "uint8"} ], "name": "setUserAccessLevel", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

export default {
  name: 'app',
  i18n,
  data() {
   return {
      localUserType: '0',
      localUserAccessLevel: '0',
      localUserValid: false,
      localUserName: '',
      showName: '',
      drawer: true,
      mini: true,
      right: null,
      logout_dialog: false,
      wallet: false,
      walletAddress: '',
      balance: '',
      current: 'home',
      network: config.getNetwork(),
      mode: config.getMode(),
      log: log,
      notifyList: {},
      items: [
        {
          title: 'Sign In',
          name: 'restore_from_key_file',
          icon: 'input'
        },
        {
          title: 'Sign Up',
          name: 'create',
          icon: 'how_to_reg'
        }
      ],
      menu: [
        {
          name: 'menu_users',
          title: 'Users',
          icon: 'supervised_user_circle',
          sub_items:[
            {
              name: 'submenu_users_find',
              title: 'Find',
              icon: 'search',
              goto: 'user_read'
            },
            {
              name: 'submenu_users_activate',
              title: 'Activate',
              icon: 'how_to_reg',
              goto: 'user_activate'
            },
            {
              name: 'submenu_users_invalidate',
              title: 'Invalidate',
              icon: 'delete',
              goto: 'user_invalidate'
            },
            {
              name: 'submenu_users_facilities',
              title: 'Health Facilities',
              icon: 'local_hospital',
              goto: 'user_facilities'
            }
          ]
        },
        {
          title: 'Patients',
          name: 'menu_patients',
          icon: 'face',
          sub_items:[
            {
              name: 'submenu_patients_create',
              title: 'Create',
              icon: 'person_add',
              goto: 'patient_create'
            },
            {
              name: 'submenu_patients_find',
              title: 'Find',
              icon: 'search',
              goto: 'patient_read'
            },
            {
              name: 'submenu_patients_invalidate',
              title: 'Invalidate',
              icon: 'delete',
              goto: 'patient_invalidate'
            }
          ]
        },
        {
          title: 'Medical Certificates',
          name: 'menu_certificates_standard',
          icon: 'description',
          sub_items:[
            {
              name: 'submenu_certstandard_create',
              title: 'Create',
              icon: 'note_add',
              goto: 'certstandard_create'
            },
            {
              name: 'submenu_certstandard_find',
              title: 'Find',
              icon: 'find_in_page',
              goto: 'certstandard_read'
            },
            {
              name: 'submenu_certstandard_invalidate',
              title: 'Invalidate',
              icon: 'delete',
              goto: 'certstandard_invalidate'
            }
          ]
        },
        {
          title: 'Certificates: Drivers',
          name: 'menu_certificates_drivers',
          icon: 'directions_car',
          sub_items:[
            {
              name: 'submenu_certdrivers_create',
              title: 'Create',
              icon: 'add',
              goto: 'certdrivers_create'
            },
            {
              name: 'submenu_certdrivers_find',
              title: 'Find',
              icon: 'find_in_page',
              goto: 'certdrivers_find'
            },
            {
              name: 'submenu_certdrivers_invalidate',
              title: 'Invalidate',
              icon: 'delete',
              goto: ''
            }
          ]
        }
      ]
    }
  },
  computed: {
    isCurrent() {
      return { [this.current]: true };
    },
    show() {
      return {
        //sign in and sign up
        create: !this.localUserValid,
        restore_from_key_file: !this.localUserValid,
        //menu
        menu_users: this.localUserValid && (this.localUserAccessLevel == '2' || this.localUserType == '3'),
          submenu_users_find: this.localUserAccessLevel == '2',
          submenu_users_activate: this.localUserAccessLevel == '2',
          submenu_users_invalidate: this.localUserAccessLevel == '2',
          submenu_users_facilities: this.localUserAccessLevel == '2' || this.localUserType == '3',
        menu_patients: this.localUserValid && (this.localUserAccessLevel == '1' || this.localUserAccessLevel == '2'),
          submenu_patients_create: this.localUserAccessLevel == '1' || this.localUserAccessLevel == '2',
          submenu_patients_find: this.localUserAccessLevel == '1' || this.localUserAccessLevel == '2',
          submenu_patients_invalidate: this.localUserAccessLevel == '2',
        menu_certificates_standard: this.localUserValid,
          submenu_certstandard_create: this.localUserAccessLevel == '1' || this.localUserAccessLevel == '2',
          submenu_certstandard_find: true,
          submenu_certstandard_invalidate: this.localUserAccessLevel == '2',
        menu_certificates_drivers: false
      }
    },
    showlogout(){
      return !(this.mode === 'offline' || !this.localUserValid);
    },
  },
  components: {
    Notify,
    Warning,
    Home,
    CreateWallet,
    RestoreKeyFile,
    ViewWallet,
    ViewTx,
    Send,
    DumpKeyFile,
    CertstandardCreate,
    CertstandardRead,
    CertstandardInvalidate,
    CertdriversCreate,
    CertdriversRead,
    UserActivate,
    UserDetails,
    UserRead,
    UserInvalidate,
    UserFacilities,
    PatientCreate,
    PatientRead,
    PatientInvalidate,
    Config,
    Help,
    HelpSignup,
    HelpSignin,
    HelpUserread,
    HelpUseractivate,
    HelpUserinvalidate,
    HelpUserfacilitiesadmin,
    HelpUserfacilities,
    HelpPatientcreate,
    HelpPatientread,
    HelpPatientinvalidate,
    HelpCertstandardcreate,
    HelpCertstandardread,
    HelpCertstandardinvalidate
  },
  methods: {
    async setWallet() {

      this.wallet = webWallet.getWallet();
      this.wallet.init();
      this.wallet.setInfo();
      this.walletAddress = this.wallet.info.address;

      try{
        const hexAddress = '0x' + base58.decode(this.walletAddress).toString('hex').substr(2, 40);
        var decodedResult = await this.callContractFunction(
          contractAddress, 
          abiJson, 
          'isUserValid', 
          [hexAddress]
        );

        this.localUserValid = decodedResult[0].toString() === 'true';

        //Get the user type and name
        decodedResult = await this.callContractFunction(
          contractAddress, 
          abiJson, 
          'getUserDetails', 
          [hexAddress]
        );

        this.localUserType = decodedResult[0].toString();
        this.localUserName = decodedResult[1].toString();

        var splitName = this.localUserName.split(" ");
        if(splitName.length >= 3){
          for (var i=1; i < splitName.length-1; i++) {
            splitName[i] = splitName[i].charAt(0)+'.';
          }
        }
        this.showName = splitName.join(" ");

      } catch (e) {
        this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e);
        alert(e.message || e);
        this.execResultDialog = false;
      }

      if(this.localUserValid){
        this.getLocalUserAccessLevel(this.walletAddress);
        this.current = 'home';
      } else {
        alert('You are not authorized. Please communicate with the system administrator.');
        this.wallet = false;
      }
    },
    logout(){
      this.wallet = null;
      this.localUserValid = false;
      this.localUserType = '';
      this.localUserAccessLevel = '';
      this.current = 'home';
      this.logout_dialog = false;
    },
    changeView(name) {
      this.current = name;
    },
    error(msg, isHtml = false, ttl = 10) {
      this.addNotify(msg, 'error', isHtml, ttl);
    },
    success(msg, isHtml = false, ttl = 10) {
      this.addNotify(msg, 'success', isHtml, ttl);
    },
    addNotify(msg, type, isHtml = false, ttl = 10) {
      const notifyId = [msg, type].join('_');
      const notify = {
        msg: msg.split(' ').reduce((msg, current) => {
          let tmsg = this.$t('common.notify.' + current)
          tmsg = (tmsg === 'common.notify.' + current) ? ' ' + current : tmsg
          return msg + tmsg
        }, ''),
        type,
        show: true,
        isHtml,
      };
      if (this.notifyList[notifyId] && this.notifyList[notifyId].timer) {
        clearTimeout(this.notifyList[notifyId].timer);
      }
      Vue.set(this.notifyList, notifyId, notify);
      if (ttl > 0) {
        this.notifyList[notifyId].timer = setTimeout(() => {
          Vue.delete(this.notifyList, notifyId)
        }, ttl * 1000);
      }
    },
    async getLocalUserAccessLevel(userAddress){
      try{
        const hexAddress = '0x' + base58.decode(userAddress).toString('hex').substr(2, 40);
        const encodedData = abi.encodeMethod(abiJson[21], [hexAddress]).substr(2);

        var encodedResult = await webWallet.getWallet().callContract(contractAddress, encodedData);          
        encodedResult = '0x' + encodedResult;
        var decodedResult = abi.decodeMethod(abiJson[21], encodedResult);

        this.localUserAccessLevel = decodedResult[0].toString();

      } catch (e) {
          this.$root.log.error('call_contract_call_contract_error', e.stack || e.toString() || e);
          alert(e.message || e);
          this.execResultDialog = false;
      } 
    },
    findIndexByName(abiJson, name){
      return abiJson.findIndex(function(item){
        return item.name === name
      });
    },

    async callContractFunction(contractAddress, abiJson, functionName, params){
      const encodedData = abi.encodeMethod(
        abiJson[
          this.findIndexByName(
            abiJson,
            functionName
          )
        ], 
        params
      ).substr(2);
      var encodedResult = await webWallet.getWallet().callContract(contractAddress, encodedData);          
      encodedResult = '0x' + encodedResult;

      return abi.decodeMethod(abiJson[this.findIndexByName(abiJson,functionName)], encodedResult);
    },

    encodeContractSendFunction(abiJson, functionName, params){
      return abi.encodeMethod(
        abiJson[this.findIndexByName(abiJson, functionName)], 
        params
      ).substr(2);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue